import {
    ChannelMemberViewProps,
    ChannelMembersViewProps,
} from './types'
import ChannelMembersView from './ChannelMembersView'
import {NinchatAttributes} from '../../api/types'
import {NinchatState} from 'api/types'
import React from 'react'
import {UserPresence} from 'types/members'

import {useSelector} from 'react-redux'

const getUserPresence = (user_attrs?: NinchatAttributes.NinchatUserAttributes): UserPresence => {
    if (user_attrs?.connected && user_attrs?.idle) {
        return 'idle'
    }
    if (user_attrs?.connected) {
        return 'online'
    }
    return 'offline'
}

export const getChannelMembers = (ninchat: NinchatState, channelId: string): Array<ChannelMemberViewProps> => {
    const {
        _users, user_attrs, user_id,
    } = ninchat
    const retval = Object.keys(ninchat?.user_channels?.[channelId]?.channel_members ?? {})
        .map((currentUserId): ChannelMemberViewProps => {
            // If the current user id is mine ?
            const userAttrs = currentUserId === user_id ? user_attrs : _users[currentUserId]?.user_attrs
            return {
                iconURL: userAttrs?.iconurl ?? '',
                presence: getUserPresence(userAttrs),
                userId: currentUserId,
                userName: userAttrs?.name ?? '',
            }
        })
        .sort((left, right): number => {
            // first sort based on online, idle, offline ( online has higher precedence )
            const weightLeft = left.presence === 'online' || left.presence === 'idle' ? 2 : 1
            const weightRight = right.presence === 'online' || right.presence === 'idle' ? 2 : 1
            // if there are multiple user with same precedence based on presence, then lexicographically sort them
            if (weightRight === weightLeft) {
                return left?.userName?.localeCompare(right?.userName)
            }
            return weightRight - weightLeft
        })

    return retval
}

// Get first nth channel members
const getFirstNthChannelMembersViewProps = (channelMembers: Array<ChannelMemberViewProps>, nCount: number): Array<ChannelMemberViewProps> => channelMembers?.filter((_, index) => index < nCount)


const ChannelMembers = ({
    channel_id, arrangeInRow, openSidebar, size,
}: {channel_id: string, arrangeInRow: boolean, openSidebar: ()=> void, size?: 'small'}): React.ReactElement => {
    const channelMembers = useSelector(({ninchat}: {ninchat: NinchatState}): Array<ChannelMemberViewProps> => getChannelMembers(ninchat, channel_id))
    const viewProps = (): ChannelMembersViewProps => {
        // if they are arranged in row by row then don't need to filter first n channel member
        const firstNthChannelMembers = arrangeInRow ? channelMembers : getFirstNthChannelMembersViewProps(channelMembers, 10)
        return {
            arrangeInRow,
            channelId: channel_id,
            channelMembers: firstNthChannelMembers,
            channelMembersCount: channelMembers.length - firstNthChannelMembers.length,
            hasMoreChannelMembers: channelMembers.length > firstNthChannelMembers.length,
            openSidebar,
            size,
        }
    }
    return <ChannelMembersView {...viewProps()} />
}

ChannelMembers.defaultProps = {size: undefined}

export default ChannelMembers
